<template>
  <header class="site-header">
    <!-- Top Bar -->
    <div class="top-bar">
      <div class="top-bar-container">
        <div class="logo-section">
          <router-link to="/" class="logo-link">
            <img :src="require('@/assets/logo.png')" alt="ŠK Batana Logo" class="logo-img" />
            <div class="logo-text">
              <h1>BATANA</h1>
              <p>Šahovski Klub</p>
            </div>
          </router-link>
        </div>

        <div class="header-actions">
          <div class="social-links">
            <a 
              href="https://www.facebook.com/SahovskiKlubBatana/" 
              target="_blank" 
              rel="noopener noreferrer"
              class="social-icon facebook"
              aria-label="Facebook"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a 
              href="https://www.youtube.com/@sahovskiklubbatana5767" 
              target="_blank" 
              rel="noopener noreferrer"
              class="social-icon youtube"
              aria-label="YouTube"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>

          <button 
            class="mobile-menu-toggle" 
            @click="toggleMobileMenu"
            :class="{ active: mobileMenuOpen }"
            aria-label="Toggle menu"
          >
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- Navigation -->
    <nav class="main-nav" :class="{ 'mobile-open': mobileMenuOpen }">
      <div class="nav-container">
        <ul class="nav-menu">
          <li class="nav-item">
            <router-link to="/" class="nav-link" @click="closeMobileMenu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              Home
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/about" class="nav-link" @click="closeMobileMenu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              O nama
            </router-link>
          </li>

          <li class="nav-item dropdown" :class="{ open: dropdownOpen }">
            <a 
              href="#" 
              class="nav-link dropdown-toggle" 
              @click.prevent="toggleDropdown"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
              </svg>
              Škola Šaha
              <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link to="/prijave" class="dropdown-link" @click="closeMobileMenu">
                  Prijave
                </router-link>
              </li>
              <li>
                <router-link to="/galerija" class="dropdown-link" @click="closeMobileMenu">
                  Galerija
                </router-link>
              </li>
              <li>
                <router-link to="/ourteam" class="dropdown-link" @click="closeMobileMenu">
                  Naš tim
                </router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link to="/ourteam" class="nav-link" @click="closeMobileMenu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              Naš tim
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/kontakt" class="nav-link" @click="closeMobileMenu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              Kontakt
            </router-link>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Mobile Menu Overlay -->
    <div 
      class="mobile-overlay" 
      :class="{ active: mobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>
  </header>
</template>

<script>
export default {
  name: "HeaderNavbar",
  data() {
    return {
      mobileMenuOpen: false,
      dropdownOpen: false,
    };
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        this.dropdownOpen = false;
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      this.dropdownOpen = false;
      document.body.style.overflow = '';
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
/* Site Header */
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Top Bar */
.top-bar {
  background: white;
  padding: 20px 0;
  border-bottom: 1px solid #e2e8f0;
}

.top-bar-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  flex: 1;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 15px;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo-link:hover {
  transform: scale(1.02);
}

.logo-img {
  width: 70px;
  height: 70px;
  transition: transform 0.3s ease;
}

.logo-link:hover .logo-img {
  transform: rotate(5deg);
}

.logo-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.logo-text h1 {
  font-size: 1.75rem;
  font-weight: 900;
  color: #1a1a2e;
  margin: 0;
  letter-spacing: 1px;
}

.logo-text p {
  font-size: 0.875rem;
  color: #667eea;
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Header Actions */
.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon svg {
  width: 20px;
  height: 20px;
  color: #4a5568;
  transition: color 0.3s ease;
}

.social-icon.facebook:hover {
  background: #1877f2;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(24, 119, 242, 0.4);
}

.social-icon.facebook:hover svg {
  color: white;
}

.social-icon.youtube:hover {
  background: #ff0000;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.4);
}

.social-icon.youtube:hover svg {
  color: white;
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.hamburger-line {
  width: 100%;
  height: 3px;
  background: #1a1a2e;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.mobile-menu-toggle.active .hamburger-line:nth-child(1) {
  transform: translateY(10.5px) rotate(45deg);
  background: white;
}

.mobile-menu-toggle.active .hamburger-line:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active .hamburger-line:nth-child(3) {
  transform: translateY(-10.5px) rotate(-45deg);
  background: white;
}

/* Main Navigation */
.main-nav {
  background: linear-gradient(135deg, #1a1a2e 0%, #2d3748 100%);
}

.nav-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.nav-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 5px;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 20px;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.nav-link svg:not(.dropdown-arrow) {
  width: 18px;
  height: 18px;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: white;
  background: rgba(102, 126, 234, 0.2);
}

.nav-link.router-link-active {
  background: rgba(102, 126, 234, 0.3);
}

/* Dropdown */
.dropdown {
  position: relative;
}

.dropdown-toggle {
  cursor: pointer;
}

.dropdown-arrow {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  transition: transform 0.3s ease;
}

.dropdown.open .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #1a1a2e;
  min-width: 200px;
  list-style: none;
  margin: 0;
  padding: 8px 0;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
}

/* Hover only on desktop */
@media (min-width: 769px) {
  .dropdown:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

.dropdown-link {
  display: block;
  padding: 12px 24px;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 0.9375rem;
  transition: all 0.3s ease;
}

.dropdown-link:hover,
.dropdown-link.router-link-active {
  color: white;
  background: rgba(102, 126, 234, 0.2);
  padding-left: 30px;
}

/* Mobile Overlay */
.mobile-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.mobile-overlay.active {
  opacity: 1;
  pointer-events: auto;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .nav-menu {
    gap: 2px;
  }

  .nav-link {
    padding: 18px 15px;
    font-size: 0.9375rem;
  }

  .nav-link svg:not(.dropdown-arrow) {
    display: none;
  }
}

@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: flex;
    position: relative;
    z-index: 1002;
  }

  .mobile-menu-toggle.active {
    position: fixed;
    right: 20px;
  }

  .main-nav {
    position: fixed;
    top: 0;
    right: -100%;
    width: 280px;
    height: 100vh;
    background: linear-gradient(135deg, #1a1a2e 0%, #2d3748 100%);
    transition: right 0.3s ease;
    z-index: 999;
    overflow-y: auto;
  }

  .main-nav.mobile-open {
    right: 0;
  }

  .nav-container {
    padding: 80px 0 20px;
  }

  .nav-menu {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }

  .nav-item {
    width: 100%;
  }

  .nav-link {
    padding: 16px 30px;
    justify-content: flex-start;
    border-radius: 0;
  }

  .nav-link svg:not(.dropdown-arrow) {
    display: block;
  }

  .dropdown-menu {
    position: static;
    opacity: 1;
    visibility: visible;
    max-height: 0;
    overflow: hidden;
    transform: none;
    box-shadow: none;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.2);
    transition: max-height 0.3s ease, padding 0.3s ease;
    padding: 0;
  }

  .dropdown.open .dropdown-menu {
    max-height: 300px;
    padding: 8px 0;
  }

  .dropdown-link {
    padding: 12px 30px 12px 50px;
  }

  .dropdown-link:hover,
  .dropdown-link.router-link-active {
    padding-left: 55px;
  }

  .mobile-overlay {
    display: block;
  }
  
  .mobile-overlay.active {
    right: 280px; /* Width of mobile menu */
  }
}

@media (max-width: 480px) {
  .logo-img {
    width: 60px;
    height: 60px;
  }

  .logo-text h1 {
    font-size: 1.5rem;
  }

  .logo-text p {
    font-size: 0.8125rem;
  }

  .social-icon {
    width: 36px;
    height: 36px;
  }

  .social-icon svg {
    width: 18px;
    height: 18px;
  }

  .main-nav {
    width: 100%;
  }
}
</style>